import { useSiteStore } from '~/stores/site.store';

type DeviceType = 'iPhone' | 'Android' | 'Huawei' | 'Desktop';

export default defineNuxtPlugin({
  dependsOn: ['init-client'],
  parallel: true,
  name: 'directives',
  setup() {
    const config = useSiteStore();

    const lookupFeature = (key: string): boolean => {
      return config.getFeatureFlags.get(key) || false;
    };

    window.$enabled = lookupFeature;
    window.$featureFlagKeys = () => Array.from(config.getFeatureFlags.keys());

    const displayApps = computed(
      () =>
        lookupFeature('website.enableappdownload') ||
        lookupFeature('website.enableandroidappdownload') ||
        lookupFeature('website.enablegoogleplayappdownload') ||
        lookupFeature('website.enableappleappdownload') ||
        lookupFeature('website.enablehuaweiappdownload'),
    );

    const devicesList: string[] = ['iPhone', 'Android', 'Huawei'];

    const deviceName = computed<DeviceType>(() => {
      const currentDeviceName: string = devicesList.find(
        (device) => navigator.userAgent.toString().indexOf(device) > -1,
      );
      return (
        !!currentDeviceName ? currentDeviceName : 'Desktop'
      ) as DeviceType;
    });

    const displayApple = computed(
      () =>
        (deviceName.value === 'iPhone' || deviceName.value === 'Desktop') &&
        lookupFeature('website.enableappleappdownload'),
    );
    const displayAndroid = computed(
      () =>
        (deviceName.value === 'Desktop' ||
          deviceName.value === 'Android' ||
          deviceName.value === 'Huawei') &&
        lookupFeature('website.enableandroidappdownload'),
    );
    const displayHuawei = computed(
      () =>
        (deviceName.value === 'Desktop' ||
          deviceName.value === 'Android' ||
          deviceName.value === 'Huawei') &&
        lookupFeature('website.enablehuaweiappdownload'),
    );

    const displayGooglePlay = computed(
      () =>
        (deviceName.value === 'Desktop' ||
          deviceName.value === 'Android' ||
          deviceName.value === 'Huawei') &&
        lookupFeature('website.enablegoogleplayappdownload'),
    );

    const isApple = computed(() => deviceName.value === 'iPhone');
    const isAndroid = computed(() => deviceName.value === 'Android');
    const isHuawei = computed(() => deviceName.value === 'Huawei');
    return {
      provide: {
        enabled: lookupFeature,
        displayApps,
        deviceName,
        displayApple,
        displayAndroid,
        displayHuawei,
        displayGooglePlay,
        isApple,
        isAndroid,
        isHuawei,
      },
    };
  },
});
